"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import Image from "next/image";
import * as React from "react";
import { getProviderMetadata } from "@/lib/services/etl-automation/automation-options";
import { cn } from "@/lib/utils";
interface ProviderIconProps {
  providerId: string;
  size?: number;
  className?: string;
}

/**
 * Renders a provider logo by ID. Single source of truth for provider icons
 * across automation card, row, detail view, and step selector.
 */
export function ProviderIcon(t0) {
  const $ = _c(28);
  let className;
  let providerIconProps;
  let providerId;
  let t1;
  if ($[0] !== t0) {
    ({
      providerId,
      size: t1,
      className,
      ...providerIconProps
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = providerIconProps;
    $[3] = providerId;
    $[4] = t1;
  } else {
    className = $[1];
    providerIconProps = $[2];
    providerId = $[3];
    t1 = $[4];
  }
  const size = t1 === undefined ? 16 : t1;
  let t2;
  if ($[5] !== providerId) {
    t2 = getProviderMetadata(providerId);
    $[5] = providerId;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const {
    icon,
    displayName
  } = t2;
  if (!icon) {
    return null;
  }
  const isImageIcon = typeof icon === "string" || typeof icon === "object" && "src" in icon;
  if (isImageIcon) {
    let t3;
    if ($[7] !== icon || $[8] !== size) {
      t3 = typeof icon === "string" ? {
        height: size,
        src: icon,
        width: size
      } : {
        ...icon,
        height: size,
        width: size
      };
      $[7] = icon;
      $[8] = size;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    const imageProps = t3;
    let t4;
    if ($[10] !== className) {
      t4 = cn("shrink-0 object-contain", className);
      $[10] = className;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    let t5;
    if ($[12] !== displayName || $[13] !== imageProps || $[14] !== providerIconProps || $[15] !== t4) {
      t5 = <Image {...providerIconProps} {...imageProps} alt={displayName} className={t4} />;
      $[12] = displayName;
      $[13] = imageProps;
      $[14] = providerIconProps;
      $[15] = t4;
      $[16] = t5;
    } else {
      t5 = $[16];
    }
    return t5;
  }
  let t3;
  if ($[17] !== className || $[18] !== icon || $[19] !== size) {
    let t4;
    if ($[21] !== className) {
      t4 = cn("inline-flex shrink-0", className);
      $[21] = className;
      $[22] = t4;
    } else {
      t4 = $[22];
    }
    let t5;
    if ($[23] !== size) {
      t5 = {
        height: size,
        width: size
      };
      $[23] = size;
      $[24] = t5;
    } else {
      t5 = $[24];
    }
    let t6;
    if ($[25] !== t4 || $[26] !== t5) {
      t6 = {
        className: t4,
        style: t5
      };
      $[25] = t4;
      $[26] = t5;
      $[27] = t6;
    } else {
      t6 = $[27];
    }
    t3 = React.cloneElement(icon as React.ReactElement<React.ComponentProps<"span">>, t6);
    $[17] = className;
    $[18] = icon;
    $[19] = size;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  return t3;
}